import { render } from "./SlotSkin.vue?vue&type=template&id=100d83c0&scoped=true&ts=true"
import script from "./SlotSkin.vue?vue&type=script&lang=ts"
export * from "./SlotSkin.vue?vue&type=script&lang=ts"

import "./SlotSkin.vue?vue&type=style&index=0&id=100d83c0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-100d83c0"]])

export default __exports__